<template>
  <div class="upload_image2">
    <div class="__upload-image" v-loading="isLoading">
      <el-image ref="img" :src="'/api'+value" fit="cover" :preview-src-list="['/api'+value]">
        <div slot="error" class="error_img">
          <!-- <i class="el-icon-user"></i> -->
          <div style="margin-top:26%;">证书图片</div>
        </div>
      </el-image>
      <div class="__image-buttons" v-if="value">
        <i class="el-icon-zoom-in" @click="onPreview"></i>
        <el-popconfirm title="确定删除吗？" v-if="showDel" @confirm="onDelete">
          <i class="el-icon-delete" slot="reference" style="margin-left:10px"></i>
        </el-popconfirm>
      </div>
    </div>
    <div class="upload_btn" :style="isMB?'margin: 15px 0 10px':''">
      <el-upload
        :headers="header"
        :action="uploadUrl"
        :before-upload="beforePhotoUpload"
        :on-success="onUploadSuccess"
        :show-file-list="false"
        accept=".jpg,.png,.jpeg"
        :data="data"
      >
        <el-button size="mini" style="width: 140px;" type="primary" icon="el-icon-upload2">上传图片</el-button>
      </el-upload>
    </div>
  </div>
</template>
<script>
import api from "@/api/po/junior6";
export default {
  props: {
    value: {
      type: String,
      default: undefined,
    },
    uploadUrl: {
      type: String,
      default: api.uploadPicture,
    },
    deleteFunc: {
      type: Function,
      default: api.deletePhoto,
    },
    type: {
      type: String,
      default: undefined,
    },
    data: {
      type: Object,
      default: null,
    },
    showDel: {
      type: Boolean,
      default: true,
    },
    IsDetail: {
      type: Boolean,
      default: false,
    },
    tip: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      isMB: this.$store.state.isMB,
    };
  },
  computed: {
    header() {
      let token = localStorage.getItem("token");
      if (token) {
        return { Authorization: "Bearer " + token };
      }
      return {};
    },
  },
  methods: {
    onUploadSuccess(res, file, fileList) {
      if(res.Code==0) {
        this.$emit("input", "" + res.Data);
      } else this.$message.error(res.Msg);
    },
    onDelete() {
      this.$emit("input", "");
    },
    beforePhotoUpload(file) {
      var _this = this;
      return new Promise((resolve, reject) => {
        try {
          var reader = new FileReader();
          // 将文件加载进入
          reader.readAsDataURL(file);
          reader.onload = function (e) {
            var base64 = reader.result;
            console.log("原", (base64.length * 0.75) / 1024);
            _this.dealImage(base64, function (new_base64) {
              console.log("后", (new_base64.length * 0.75) / 1024);
              var new_file = _this.dataURLtoFile(new_base64, file.name);
              console.log("new_file", new_file);
              resolve(new_file);
            });
          };
        } catch (error) {
          reject(error);
        }
      });
    },
    dealImage(base64, callback) {
      var newImage = new Image();
      var quality = 1; //压缩系数0-1之间
      newImage.src = base64;
      newImage.setAttribute("crossOrigin", 'Anonymous'); //url为外域时需要
      var imgWidth, imgHeight;
      newImage.onload = function() {
        imgWidth = this.width;
        imgHeight = this.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (imgWidth > 1080 || imgHeight > 1080) {
          if (imgHeight > imgWidth) {
            canvas.height = 1080;
            var ratio = imgWidth / imgHeight;
            canvas.width = canvas.height * ratio;
          } else {
            canvas.width = 1080;
            var ratio = imgWidth / imgHeight;
            canvas.height = canvas.width / ratio;
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
        var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
        // console.log("??!-*",base64.length)
        // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
        while (base64.length *0.75 / 1024 > 200) {
        	quality -= 0.1;
        	base64 = canvas.toDataURL("image/jpeg", quality);
          // console.log("压缩")
        }
        callback(base64); //必须通过回调函数返回，否则无法及时拿到该值
      }
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onPreview() {
      this.$refs.img.clickHandler();
    },
  },
};
</script>

<style lang="scss">
.upload_image2 {
  width: 100%;
  .__upload-area {
    border: 1px dashed #c0ccda;
    // border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    line-height: 120px;
    width: 120px;
    height: 120px;
    font-size: 32px;
    color: #8c939d;
  }
  .__upload-area:hover {
    border-color: #409eff;
  }
  .__upload-image {
    border: 1px solid #c0ccda;
    overflow: hidden;
    width: 140px;
    height: 90px;
    margin: auto;
    position: relative;
    .el-image {
      width: 100%;
      height: 100%;
      // object-fit: cover;
    }
    // .error_img {
    //   font-size: 96px;
    //   text-align: center;
    //   padding-top: 23px;
    //   color: #959595;
    // }
    .__image-buttons {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      opacity: 0;
      background: rgba(0, 0, 0, 0.5);
      line-height: 90px;
      color: #ffffff;
      transition: opacity 0.3s;
      text-align: center;
      i {
        font-size: 18px;
        cursor: pointer;
      }
      i + i {
        margin-left: 10px;
      }
    }
    .__image-buttons:hover {
      opacity: 1;
    }
  }
}

.upload_btn {
  width: 100%;
  text-align: center;
  margin-top: 6px;
}
</style>